export enum ProductDatingUponReceiptIssueTypeDomestic {
    CUSTOMER_DISSATISFACTION = 'Customer Dissatisfaction'
}
